import { render, staticRenderFns } from "./QuestionImageVertical.vue?vue&type=template&id=038d06f2&scoped=true&lang=pug&"
import script from "./QuestionImageVertical.vue?vue&type=script&lang=ts&"
export * from "./QuestionImageVertical.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionImageVertical.vue?vue&type=style&index=0&id=038d06f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d06f2",
  null
  
)

export default component.exports